
<div class="mb-2">
  <div class="label mt-3 mb-1">Priority</div>

  <div class="btn-group d-flex align-items-center" role="group">
    <button
      type="button"
      class="btn btn-xs"
      v-bind:class="{
        'btn-primary': item.priority === priority.Normal,
        'btn-outline-primary': item.priority !== priority.Normal,
      }"
      v-on:click="updatePriority(priority.Normal)"
    >
      {{ priority.Normal }}
    </button>
    <button
      type="button"
      class="btn btn-xs"
      v-bind:class="{
        'btn-danger': item.priority === priority.High,
        'btn-outline-danger': item.priority !== priority.High,
      }"
      v-on:click="updatePriority(priority.High)"
    >
      {{ priority.High }}
    </button>
  </div>
</div>
